import type { CustomerEnterpriseAuthVo, PersonalAuthParams } from "../../../../common/types/certification";
import { SIGN_ORIGIN } from "../../../../common/enum/common";
import httpRequest from ".";

// 换绑手机号（契约锁）
class CertificationPhoneService {
    private readonly path: string;
    private service: any;

    constructor(path: string, service: any) {
        this.path = path;
        this.service = service;
    }

    /** 换绑手机号-获取客户个人认证链接 */
    async getPersonalAuth(params: PersonalAuthParams) {
        const { data } = await this.service.post(`${this.path}/personal/auth?origin=${SIGN_ORIGIN.PC.code}`, params);
        return data;
    }

    /** 换绑手机号-获取企业认证 */
    async getEnterpriseAuth(): Promise<CustomerEnterpriseAuthVo> {
        const { data } = await this.service.post(`${this.path}/enterprise/auth?origin=${SIGN_ORIGIN.PC.code}`);
        return data;
    }

    /** 换绑手机号-获取授权认证 */
    async getEnterpriseAuthorize(institutionName: string) {
        const { data } = await this.service.get(
            `${this.path}/enterprise/authorize?institutionName=${institutionName}&origin=${SIGN_ORIGIN.PC.code}`
        );
        return data;
    }

    /** 换绑手机号-提交企业认证记录 */
    async submitEnterpriseAuthorize(institutionName: string) {
        const { data } = await this.service.get(`${this.path}/enterprise/submit?institutionName=${institutionName}`);
        return data;
    }

    /** 换绑手机号-查询用户认证详情 */
    async getUserAuthDetail() {
        const { data } = await this.service.get(`${this.path}/detail`);
        return data;
    }
}
export const certificationPhoneService = new CertificationPhoneService("/customer/certification/change", httpRequest);
